import React from "react";
import loading from "../assets/loading.svg";

const Loading = () => (
  <div className="spinner_page">
    <div className="spinner_page_a">
      <img src={loading} alt="Loading" />
    </div>
  </div>
);

export default Loading;
